import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {NotificationListModel} from "../_models/NotificationListModel";
import {ModelKey} from "../../../models/ModelKey";
import {AppEvent} from "../../../event-buses/AppEvent";

export const IT_NOTIFICATION_LIST_CONTROLLER = new InjectionToken<INotificationListController>('IT_NOTIFICATION_LIST_CONTROLLER');
export const MK_NOTIFICATION_LIST = new ModelKey<NotificationListModel>('MK_NOTIFICATION_LIST');

export interface INotificationListController extends IController {

  handleNotificationListToggled(eventData: any): void;
  handleRemoveAlertInstance(eventData: any): void;
  handleRemoveAll(eventData: any): void;
  handleNavigateToAlertMonitor(eventData: any): void;

  onAlertNotification(event: AppEvent): void;
  onAlertSelection(event: AppEvent): void;
}
